
import React from 'react'
import { Box, Typography } from '@material-ui/core'

export const ErrorMessage = (props) => {
  return (
    <Box paddingX={2}>
      <Typography variant="body2" color="error">
        {props.error}
      </Typography>
    </Box>
  )
}